module.exports = __webpack_public_path__ + "7f40b8d3ed74811ac9f6ffb2d577ccda.svg";